export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  INFO: 'ALERT_INFO',
  WARNING: 'ALERT_WARNING',
  CLEAR: 'ALERT_CLEAR'
};
